import { useEffect, useState } from "react";
import { fechaSync } from "../utils/syncAS400";

// Banda roja fija + mensaje emergente (una vez por sesión) cuando Korvantis lleva más de 26 h
// sin sincronizar con el AS/400. El estado llega de useSyncAS400 en App.js.
export default function AvisoSincronizacion({ sync }) {
  const [verModal, setVerModal] = useState(false);

  useEffect(() => {
    if (!sync?.bloqueado) return;
    let visto = false;
    try { visto = sessionStorage.getItem("aviso_sin_sync_visto") === "1"; } catch (e) { /* sin storage */ }
    if (!visto) setVerModal(true);
  }, [sync?.bloqueado]);

  if (!sync?.bloqueado) return null;
  const cerrar = () => {
    try { sessionStorage.setItem("aviso_sin_sync_visto", "1"); } catch (e) { /* sin storage */ }
    setVerModal(false);
  };

  return (
    <>
      <div style={banda} role="alert">
        ⚠️ <b>Sin conexión con el sistema</b> desde el {fechaSync(sync.ultima)}. Pedidos desactivados hasta que se resuelva; fichas y cobros funcionan con normalidad.
      </div>
      {verModal && (
        <div style={fondo}>
          <div style={caja} role="alertdialog" aria-modal="true">
            <div style={{ fontSize: 40 }}>⚠️</div>
            <h2 style={{ margin: "6px 0 10px", color: "#B42318" }}>Sin conexión con el sistema</h2>
            <p style={p}>Korvantis no ha podido actualizarse desde el <b>{fechaSync(sync.ultima)}</b>, así que los precios, las ofertas y el stock podrían no estar al día.</p>
            <p style={p}>Mientras dure la incidencia <b>no se pueden hacer ni enviar pedidos</b>. Puedes consultar las fichas de tus clientes y registrar cobros con normalidad.</p>
            <p style={p}>Disculpa las molestias: ya estamos trabajando para solucionarlo.</p>
            <button onClick={cerrar} style={btn}>Entendido</button>
          </div>
        </div>
      )}
    </>
  );
}

const banda = { background: "#B42318", color: "white", padding: "10px 16px", fontSize: 14, lineHeight: 1.4, textAlign: "center", position: "sticky", top: 0, zIndex: 1000 };
const fondo = { position: "fixed", inset: 0, background: "rgba(16,42,67,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000, padding: 16 };
const caja = { background: "white", borderRadius: 18, padding: 24, maxWidth: 440, width: "100%", textAlign: "center", boxShadow: "0 12px 40px rgba(0,0,0,0.25)" };
const p = { margin: "0 0 10px", fontSize: 15, lineHeight: 1.5, color: "#243B53" };
const btn = { marginTop: 8, background: "#102A43", color: "white", border: "none", borderRadius: 12, padding: "12px 22px", fontSize: 15, fontWeight: 700, cursor: "pointer", width: "100%" };
